import { Component } from '@angular/core';

import { TerraIconModule } from '@ninety/terra';

import { MazMessageSender } from '../../models/maz-message-sender.enum';

@Component({
  selector: 'ninety-maz-waiting-for-response',
  template: `<div class="message-box">
    <div class="maz-icon"><terra-icon icon="sparkle" variant="fill" size="12" /></div>
    <div class="chat-ellipsis"></div>
    <!--<div>Just a second...</div>-->
  </div>`,
  styleUrls: ['./maz-waiting-for-response.component.scss'],
  standalone: true,
  imports: [TerraIconModule],
})
export class MazWaitingForResponseComponent {
  protected readonly MazMessageSender = MazMessageSender;
}
